<div class="card tui-space_auto" *ngIf="!(isDemoMode$ | async); else isDemoModeTemplate">
  <h2 class="tui-text_h2 ait-text-align-center">{{ '👋 Welcome!' | translate }}</h2>
  <div class="card-body tui-space_vertical-4">
    <div class="card-body__border">
      <span class="card-body__circle"></span>
      <span class="card-body__circle"></span>
      <span class="card-body__circle"></span>
    </div>
    <div
      class="card-body__block card-body__left"
      (mouseenter)="isPlayingLeft = true"
      (mouseleave)="isPlayingLeft = false"
    >
      <div class="card-body__text-block card-body__text-block--left">
        <h3 class="tui-text_h5 tui-space_bottom-2">
          <p>{{ 'Advanced overlays for DPA' | translate }}</p>
          <i class="card-body__text-italic">{{ 'Facebook & Instagram' | translate }}</i>
        </h3>
        <p class="ait-font-text-l">
          {{ 'Design the overlay using Aitarget template editor.' | translate }}
        </p>
        <p class="ait-font-text-l">
          {{ 'Enrich creatives with product data from the feed.' | translate }}
        </p>
        <p class="ait-font-text-l">{{ 'Scale creative variables in minutes.' | translate }}</p>
        <button
          [appearance]="isPlayingLeft ? 'aitarget-onboarding-on' : 'aitarget-onboarding'"
          (click)="startOverlaysStepper()"
          tuiButton
          type="button"
          size="l"
        >
          {{ "Let's start!" | translate }}
        </button>
      </div>
      <div class="card-body__image-wrapper">
        <img
          class="card-body__image-block card-body__image-block--disabled card-body__image-block-left"
          loading="lazy"
          src="https://res.cloudinary.com/aitarget-test/image/upload/v1648030239/assets/onboarding/overlays-disabled.png"
        />
        <img
          class="card-body__image-block card-body__image-block--enabled card-body__image-block-left"
          loading="lazy"
          src="https://res.cloudinary.com/aitarget-test/image/upload/v1648030239/assets/onboarding/overlays-enabled.png"
        />
      </div>
    </div>
    <div
      class="card-body__block card-body__right"
      (mouseenter)="isPlayingRight = true"
      (mouseleave)="isPlayingRight = false"
    >
      <div class="card-body__image-wrapper">
        <img
          class="card-body__image-block card-body__image-block--disabled card-body__image-block-right"
          loading="lazy"
          src="https://res.cloudinary.com/aitarget/image/upload/v1632921461/ai-tech-examples/videos-disabled.png"
        />
        <img
          class="card-body__image-block card-body__image-block--enabled card-body__image-block-right"
          loading="lazy"
          src="https://res.cloudinary.com/aitarget/image/upload/v1632921464/ai-tech-examples/videos-enabled.gif"
        />
      </div>
      <div class="card-body__text-block card-body__text-block--right">
        <h3 class="tui-text_h5 tui-space_bottom-2">
          <p>
            {{ 'Video creatives at scale' | translate }}
          </p>
          <i class="card-body__text-italic">
            {{ 'Facebook, Instagram, YouTube & TikTok' | translate }}
          </i>
        </h3>
        <p class="ait-font-text-l">
          {{ 'Create video creatives from scratch.' | translate }}
        </p>
        <p class="ait-font-text-l">
          {{ 'Generate and scale feed-based product videos for custom product sets.' | translate }}
        </p>
        <p class="ait-font-text-l">
          {{ 'Adapt video creatives for any placement.' | translate }}
        </p>
        <button
          [appearance]="isPlayingRight ? 'aitarget-onboarding-on' : 'aitarget-onboarding'"
          (click)="startVideosStepper()"
          tuiButton
          type="button"
          size="l"
        >
          {{ "Let's start!" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
<ng-template #isDemoModeTemplate>
  <div class="card tui-space_auto">
    <h2 class="tui-text_h2 ait-text-align-center">{{ '👋 Welcome!' | translate }}</h2>
    <div class="card-body tui-space_vertical-4">
      <div class="card-body__border">
        <span class="card-body__circle"></span>
        <span class="card-body__circle"></span>
        <span class="card-body__circle"></span>
      </div>
      <div
        class="card-body__block-demo card-body__demo"
        (mouseenter)="isPlayingLeft = true"
        (mouseleave)="isPlayingLeft = false"
      >
        <div class="card-body__text-block card-body__text-block--demo">
          <h3 class="tui-text_h4 tui-space_bottom-2">
            <p>{{ 'Now you can:' | translate }}</p>
          </h3>
          <div class="card-body__demo-text-wrapper">
            <span class="card-body__demo-numbers tui-space_right-4">1</span>
            <p class="ait-font-text-l">
              {{ 'Create dynamic creatives based on product catalog' | translate }}
            </p>
          </div>
          <div class="card-body__demo-text-wrapper">
            <span class="card-body__demo-numbers tui-space_right-4">2</span>
            <p class="ait-font-text-l">
              {{ 'Replicate banners for all products in one click' | translate }}
            </p>
          </div>
          <div class="card-body__demo-text-wrapper">
            <span class="card-body__demo-numbers tui-space_right-4">3</span>
            <p class="ait-font-text-l">
              {{ 'Save up to 30% of time due to automation' | translate }}
            </p>
          </div>
          <a
            class="ait-font-text-m"
            [pseudo]="true"
            (click)="openVideoModal()"
            data-gtm-id="fb_home_how_it_work_video"
            tuiLink
          >
            <tui-svg class="tui-space_right-1" src="playSpecial"></tui-svg>
            {{ 'How does it work?' | translate }}
          </a>
          <button
            [appearance]="isPlayingLeft ? 'aitarget-onboarding-on' : 'aitarget-onboarding'"
            (click)="startOverlaysStepper()"
            data-gtm-id="fb_home_lets_start"
            tuiButton
            type="button"
            size="l"
          >
            {{ "Let's start!" | translate }}
          </button>
        </div>
        <div class="card-body__image-wrapper">
          <div
            class="card-body__special-circle-demo"
            *ngIf="isPlayingLeft"
            @tuiFadeIn
            @tuiScaleIn
          ></div>
          <img
            class="card-body__image-block card-body__image-block--disabled card-body__image-block-demo"
            loading="lazy"
            src="https://res.cloudinary.com/aitarget-test/image/upload/v1648030239/assets/onboarding/overlays-disabled.png"
          />
          <img
            class="card-body__image-block card-body__image-block--enabled card-body__image-block-demo"
            loading="lazy"
            src="https://res.cloudinary.com/aitarget-test/image/upload/v1648030239/assets/onboarding/overlays-enabled.png"
          />
        </div>
      </div>
    </div>
  </div>
</ng-template>
